import { createDiMaApi } from "@org-avp/avp-avengers-dima-service-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { FetchBaseQueryArgs } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../utils/header.utils";

const baseQueryArgs: FetchBaseQueryArgs = {
  baseUrl: environment.NX_MATERIAL_SERVICE_BASE_URL,
  prepareHeaders,
};

export const diMaApi = createDiMaApi({
  baseQueryArgs,
});
